import React from "react";
import DummyLayout from "../Dummylayout";
import Basiccard from "../BasicCard";
import TeamCards from "../TeamCards";
const  id = localStorage.getItem('employeeid');
function MyTeamAppraisal ()
{
    return(
        <>
        <DummyLayout/>
      
        <Basiccard>
            <TeamCards managerId={id}/>
        </Basiccard>
        </>
    )
}
export default MyTeamAppraisal;